<template>
    <div>
        <div class="row" v-show="styleDataErrors.iconIsEmpty" id="icon-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy wybrać ikonę lub kształt.
            </small>
        </div>
        <div class="form-group row" v-if="shape === null">
            <label for="single-symbol-icon" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Ikona</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <icon-picker v-model="icon" id="single-symbol-icon" :class="{ 'is-invalid': styleDataErrors.iconIsEmpty }" :aria-required="shape === null" :aria-invalid="styleDataErrors.iconIsEmpty" :aria-describedby="styleDataErrors.iconIsEmpty ? 'icon-empty-description' : ''" :type="iconPickerType"/>
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-shape" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kształt</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-select v-model="shape" :options="shapesList" id="single-symbol-shape" @input="icon = (shape ? null : icon)"></b-form-select>                 
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.shapeSizeEmpty" id="shape-size-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy podać wielkość kształtu.
            </small>
        </div>
        <div class="row" v-show="styleDataErrors.shapeSizeNotInRange" id="shape-size-range-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Wielkość kształtu powinna zawierać się w przedziale od 1 do 255.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-shape-size" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Wielkość kształtu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-input v-model="shapeSize" type="number" id="single-symbol-shape-size" min="1" max="255" class="form-control" :class="{ 'is-invalid': styleDataErrors.shapeSizeEmpty || styleDataErrors.shapeSizeNotInRange }" aria-required="true" :aria-invalid="styleDataErrors.shapeSizeEmpty || styleDataErrors.shapeSizeNotInRange" :aria-describedby="styleDataErrors.shapeSizeEmpty ? 'shape-size-empty-description' : (styleDataErrors.shapeSizeNotInRange ? 'shape-size-range-description' : '')"></b-form-input>             
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-fill-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor wypełnienia</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="fillColor" id="single-symbol-fill-color" />
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-style" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Styl obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-select v-model="strokeStyle" :options="strokeStylesList" id="single-symbol-stroke-style"></b-form-select>                 
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeEmpty" id="stroke-size-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy podać szerokość obrysu.
            </small>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeNotInRange" id="stroke-size-range-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Szerokość obrysu powinna zawierać się w przedziale od 1 do 255.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-size" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Szerokość obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-input v-model="strokeSize" type="number" id="single-symbol-stroke-size" min="1" max="255" class="form-control" :class="{ 'is-invalid': styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange }" :aria-required="strokeStyle !== null" :aria-invalid="styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange" :aria-describedby="styleDataErrors.strokeSizeEmpty ? 'stroke-size-empty-description' : (styleDataErrors.strokeSizeNotInRange ? 'stroke-size-range-description' : '')"></b-form-input>             
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="strokeColor" id="single-symbol-stroke-color" />
            </div>
        </div>
    </div>
</template>

<script>
import ColorPicker from "../../ColorPicker.vue";
import IconPicker from "../../IconPicker.vue";
import LayerStyleStore from "../store/LayerStyleStore";

export default {
  name: "FormLayerStylePointSingleSymbol",
  props: {
    size: String,
    iconPickerType: String
  },
  data() {
    return {
      icon: null,
      shape: "circle",
      shapeSize: 12,
      fillColor: { r: 255, g: 255, b: 0, a: 1 },
      strokeStyle: [1],
      strokeSize: 3,
      strokeColor: { r: 255, g: 0, b: 255, a: 1 },
      shapesList: [
        { text: "Wybierz", value: null },
        { text: "Kółko", value: "circle" },
        { text: "Kwadrat", value: "square" },
        { text: "Trójkąt", value: "triangle" },
        { text: "Gwiazdka", value: "star" },
        { text: "Krzyżyk", value: "cross" }
      ],
      strokeStylesList: [
        { text: "Wybierz", value: null },
        { text: "Kreskowany", value: [4, 4] },
        { text: "Kropkowany", value: [1, 1] },
        { text: "Ciągły", value: [1] }
      ],
      styleDataErrors: {
        iconIsEmpty: false,
        shapeSizeEmpty: false,
        shapeSizeNotInRange: false,
        strokeSizeEmpty: false,
        strokeSizeNotInRange: false
      }
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getPointSingleSymbol();
    if (initialValue != null && initialValue.reguly !== undefined && initialValue.reguly.length !== 0) {
      this.icon = initialValue.reguly[0].sygnatura.punkt.ikona;
      this.shape = initialValue.reguly[0].sygnatura.punkt.ksztalt;
      this.shapeSize = initialValue.reguly[0].sygnatura.punkt.rozmiar;
      this.fillColor = initialValue.reguly[0].sygnatura.wypelnienie.kolor;
      this.strokeStyle = initialValue.reguly[0].sygnatura.obrys.kreskowanie;
      this.strokeSize = initialValue.reguly[0].sygnatura.obrys.szerokosc;
      this.strokeColor = initialValue.reguly[0].sygnatura.obrys.kolor;
    }
  },
  methods: {
    updateValue() {
        let store = new LayerStyleStore();
        store.setPointSingleSymbol({
        reguly: [
        {
          filtr: null,
          sygnatura: {
            obrys: {
              kolor: this.strokeColor,
              kreskowanie: this.strokeStyle,
              szerokosc: this.strokeSize ? parseInt(this.strokeSize) : null
            },
            punkt: {
              ikona: this.icon,
              ksztalt: this.shape,
              rozmiar: this.shapeSize ? parseInt(this.shapeSize) : null
            },
            wypelnienie: {
              kolor: this.fillColor
            }
          }
        }]});
        this.$emit('updated');
    },
    validate() {
      this.updateValue();
      var vm = this;
      Object.keys(this.styleDataErrors).forEach(
        x => (vm.styleDataErrors[x] = false)
      );
      if (this.shape === null && this.icon === null) {
        this.styleDataErrors.iconIsEmpty = true;
      }
      if (this.shapeSize === "") {
        this.styleDataErrors.shapeSizeEmpty = true;
      } else if (this.shapeSize < 1 || this.shapeSize > 255) {
        this.styleDataErrors.shapeSizeNotInRange = true;
      }
      if (this.strokeStyle !== null) {
        if (this.strokeSize === "") {
          this.styleDataErrors.strokeSizeEmpty = true;
        } else if (this.strokeSize < 1 || this.strokeSize > 255) {
          this.styleDataErrors.strokeSizeNotInRange = true;
        }
      }
      return Object.keys(this.styleDataErrors).some(
        x => vm.styleDataErrors[x] === true
      );
    }
  },
  components: {
    ColorPicker,
    IconPicker
  }
};
</script>